import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../Controllers/hooks";
import { useSelector } from "react-redux";
import { RootState } from "../../Controllers/Store";
import { hasPermission } from "../../Controllers/Selectors/permissionsSelector";

import { Toast } from "primereact/toast";
import { Ripple } from "primereact/ripple";

import GoBackButton from "../../Components/GoBackButton";
import PageLoader from "../../Components/PageLoader";
import ErrorPage from "../../Components/ErrorPage";

import { Project } from "../../Controllers/Types/Project/ProjectInterface";
import { Employee } from "../../Controllers/Types/EmployeeInterface";
import { fetchAllProjects } from "../../Controllers/Thunks/projectThunks";
import { fetchAllDefaultPackages } from "../../Controllers/Slices/projectDetailsSlice";
import { fetchBuildingControlPermissions } from "../../Controllers/Thunks/BuildingControlThunks";


const BuildingControlPermission: React.FC = () => {
    const dispatch = useAppDispatch();
    const toast = useRef<Toast>(null);

    const [initialDataLoading, setInitialDataLoading] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);

    // BC Project
    const [showBCProjectModal, setShowBCProjectModal] = useState<boolean>(false);
    const [selectedBCProjects, setSelectedBCProjects] = useState<Project[]>([]);

    // BC Employee
    const [showEmployeeModal, setShowEmployeeModal] = useState<boolean>(false);
    const [selectedEmployees, setSelectedEmployees] = useState<Employee[]>([]);

    // State data
    const { allProjects: projects, loading: loadingProjects } = useAppSelector((state) => state.project);
    const { loadingDefaultPackage, allDefaultPackages, errorDefaultPackage } = useAppSelector((state) => state.projectDetails);
    const {
        loadingBuildingControlPermissions, errorBuildingControlPermissions, buildingControlPermissions,
    } = useAppSelector((state) => state.buildingControl);

    /* Permissions */
    const useCanEdit = (screen: string, permission: string) => {
        return useSelector((state: RootState) =>
            hasPermission(state, screen, permission)
        );
    };
    /*  */

    const buildingControlServices = useMemo(() => {
        return allDefaultPackages?.filter((service) => service?.now_available === 1 && service?.show_shortcut === 1) ?? [];
    }, [allDefaultPackages]);

    const handleGetBuildingControlPermissions = useCallback(async () => {
        try {
            await dispatch(fetchBuildingControlPermissions()).unwrap();
        } catch (error) {
            toast?.current?.show({
                severity: "error",
                summary: "Error",
                detail: "Failed to fetch building control permissions.",
                life: 3000,
            });
        } finally {
            setInitialDataLoading(false);
        }
    }, [dispatch]);

    useEffect(() => {
        dispatch(fetchAllProjects());
        dispatch(fetchAllDefaultPackages());
        handleGetBuildingControlPermissions();
    }, [
        dispatch,
        handleGetBuildingControlPermissions,
    ]);





    // ------------------------------------------- BC Project
    const handleAddBuildingControlProject = () => {
        setShowBCProjectModal(true);
    }

    const handleCloseBCProjectModal = () => {
        setShowBCProjectModal(false);
        setSelectedBCProjects([]);
    }

    const addBCProjects = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!selectedBCProjects) return;

        setLoading(true);

        try {

        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const handleSelectBCProject = (project: Project) => {
        setSelectedBCProjects((prev) => [...prev, project]);
        setShowBCProjectModal(false);
    }
    // -------------------------------------------


    // ------------------------------------------- BC Employee
    const handleAddBuildingControlEmployee = () => {
        setShowEmployeeModal(true);
    }

    const handleCloseEmployeeModal = () => {
        setShowEmployeeModal(false);
        setSelectedEmployees([]);
    }

    const addBuildingControlEmployee = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!selectedEmployees) return;

        setLoading(true);

        try {

        } catch (error) {

        } finally {
            setLoading(false);
        }
    }

    const handleSelectBuildingControlEmployee = (employee: Employee) => {
        setSelectedEmployees((prev) => [...prev, employee]);
        setShowEmployeeModal(false);
    }

    // -------------------------------------------
    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {loadingDefaultPackage && loadingBuildingControlPermissions && initialDataLoading ? (
                    <PageLoader />
                ) : (errorBuildingControlPermissions) ? (
                    <ErrorPage errorMessage={errorBuildingControlPermissions ?? ''} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="d-flex align-items-center justify-content-between">
                            <h4 className="main_heading">Building control permission </h4>

                            <GoBackButton />
                        </div>

                        <div className="page_header_area justify-content-end mt-sm-3 mt-3">
                            <div className="page_action_area">
                                <button
                                    className="add_data_link_btn p-ripple"
                                    onClick={handleAddBuildingControlProject}
                                >
                                    <i className="bi bi-plus-circle"></i>
                                    <span>Add project</span>
                                    <Ripple />
                                </button>
                            </div>
                        </div>

                        <div className="page_main_content_section">

                        </div>
                    </div>
                )}
            </div>

            
        </React.Fragment>
    );
};

export default BuildingControlPermission;